import {qs} from '@shared/helpers/queryString'
import {SchemasUniversalDelivery} from '@shared/schemas/universal'

import getApi, {createWrapper, getCommonBaseUrl} from '@web/helpers/api'

import {DeliveryPayload} from '../interfaces'

const AddressBookApi = {
    all: '/delivery/all',
    registered: '/delivery/registered',
    recent: '/delivery/recent',
}

const api = getApi(getCommonBaseUrl())

/** 배송지 목록 조회 */
const getAddressBook = () => {
    return createWrapper<SchemasUniversalDelivery['/delivery/all']['response']>(api.get(AddressBookApi.all))
}

/** 배송지 추가 */
const addAddress = ({address}: {address: Omit<DeliveryPayload, 'setAsVirtualPhoneNumberUsed'>}) => {
    const url = AddressBookApi.registered
    return createWrapper<SchemasUniversalDelivery['POST/delivery/registered']['response']>(api.post(url, {address}))
}

/** 배송지 수정 */
const editAddress = ({hash, address}: {hash: string; address: DeliveryPayload}) => {
    const url = AddressBookApi.registered
    return createWrapper<SchemasUniversalDelivery['PUT/delivery/registered']['response']>(
        api.put(
            qs.stringifyUrl({
                url,
                query: {
                    hash,
                },
            }),
            {address},
        ),
    )
}

/** 배송지 삭제 */
const deleteAddress = ({hash, type}: {hash: string; type: 'recent' | 'registered'}) => {
    const url = AddressBookApi[type]

    return createWrapper<SchemasUniversalDelivery['DELETE/delivery/registered']['response']>(
        api.delete(
            qs.stringifyUrl({
                url,
                query: {
                    hash,
                },
            }),
        ),
    )
}
export default {getAddressBook, addAddress, editAddress, deleteAddress}
